import Button from "../../components/Button/Button";
import "./Homepage.scss";
import headshot from "../../assets/images/headCutOut.png";
import HomeAbout from "../../components/HomeAbout/HomeAbout";
import HomeProjects from "../../components/HomeProjects/HomeProjects";
import HomeTestimonials from "../../components/HomeTestimonials/HomeTestimonials";
import { Link } from "react-router-dom";

export default function Homepage() {
  return (
    <div className="homepage">
      <section className="homepage__hero">
        <div className="hero__bkgd"></div>
        <div className="hero__left">
          <section className="hero__header">
            <h1 className="hero__name">Zea Zuniga</h1>
            <p className="hero__title">Web Developer</p>
          </section>
          <section className="hero__phrases">
            <p className="hero__phrase">
              Driven by <span className="hero__phrase--bold">Faith</span>
            </p>
            <p className="hero__phrase">
              Focused on <span className="hero__phrase--bold">Excellence</span>
            </p>
          </section>
          <section className="hero__buttonContainer">
            <Link to="/services">
              <Button
                content="Let's Start Building"
                classtitle="button button--primary button__hero--1"
              />
            </Link>
            <a href="#contact">
              <Button
                content="Contact Me"
                classtitle="button button--secondary button__hero--2"
              />
            </a>
          </section>
        </div>
        <div className="hero__right">
          <section className="hero__borderAccent hero__borderAccent--top"></section>
          <section className="hero__borderAccent hero__borderAccent--right"></section>
          <section className="hero__borderAccent hero__borderAccent--bottom"></section>
          <section className="hero__borderAccent hero__borderAccent--left"></section>
          <img
            src={headshot}
            alt="Headshot of Zea Zuniga"
            className="hero__img"
          />
        </div>
      </section>
      <HomeAbout />
      <HomeProjects />
      <HomeTestimonials />
    </div>
  );
}
